import api from "../api/axios";

export const mergeOrders = async ({
  order1_id,
  order2_id,
  delivery_date,
  comment,
  manual_changes,
}) => {
  const body = { order1_id, order2_id, delivery_date };
  if (comment) body.comment = comment;
  if (manual_changes) {
    const filtered = Object.fromEntries(
      Object.entries(manual_changes).filter(([, v]) => v !== undefined && v !== "")
    );
    if (Object.keys(filtered).length) body.manual_changes = filtered;
  }
  const response = await api.post("/orders/merge", body);
  return response.data;
};
